import { inject, Pipe, PipeTransform } from '@angular/core';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';
import { LicenseType } from 'mbs-ui-shared@models';

@Pipe({
  name: 'licenseType',
  standalone: true,
  pure: false
})
export class LicenseTypePipe implements PipeTransform {
  private licensesSignalFacade = inject(LicensesSignalFacade);

  transform(value: LicenseType, defaultValue = '-'): string {
    return this.licensesSignalFacade.allLicenseTypesMap()?.get(value) ?? defaultValue;
  }
}
